import http from './http';

// export const studies = async (token) => http.post('/studies', token).then(({ data }) => data);

export const register = async (user) => http().post('/register', user).then(({ data }) => data);

export const login = async (user) => http().post('/login', user).then(({ data }) => {
  localStorage.setItem('user', JSON.stringify(data));
});

export const logout = async () => http().post('/logout', {}).then(() => {
  localStorage.removeItem('user');
});

export const recoverPassword = async (email) => http().post('/request_reset_password', email).then(() => {});

export const submitNewPassword = async (user) => http().post('/reset_password', user).then(() => {});

// export const getCurrentUser = () => JSON.parse(localStorage.getItem('user'));
